var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.8359 39.0348L38.9176 31.1164L32.827 28.6001C34.8549 25.7161 35.9414 22.2756 35.9375 18.75C35.9375 9.27275 28.2272 1.5625 18.75 1.5625C9.27275 1.5625 1.5625 9.27275 1.5625 18.75C1.5625 28.2272 9.27275 35.9375 18.75 35.9375C22.3063 35.9416 25.7753 34.8363 28.6737 32.7757L31.1835 38.8499L39.1016 46.7687C39.6094 47.2765 40.2122 47.6794 40.8758 47.9542C41.5393 48.2291 42.2504 48.3705 42.9686 48.3706C43.6868 48.3706 44.3979 48.2292 45.0614 47.9543C45.725 47.6795 46.3278 47.2767 46.8357 46.7689C47.3435 46.2611 47.7464 45.6582 48.0212 44.9947C48.2961 44.3312 48.4376 43.6201 48.4376 42.9019C48.4376 42.1837 48.2962 41.4725 48.0214 40.809C47.7466 40.1455 47.3438 39.5426 46.8359 39.0348ZM4.6875 18.75C4.6875 10.9961 10.9961 4.6875 18.75 4.6875C26.5039 4.6875 32.8125 10.9961 32.8125 18.75C32.8125 26.5039 26.5039 32.8125 18.75 32.8125C10.9961 32.8125 4.6875 26.5039 4.6875 18.75ZM44.6261 44.559C44.1862 44.9979 43.5901 45.2444 42.9688 45.2444C42.3474 45.2444 41.7513 44.9979 41.3114 44.559L33.8337 37.0812L31.5003 31.4333L37.1484 33.7667L44.6263 41.2444C45.0651 41.6843 45.3115 42.2804 45.3115 42.9017C45.3115 43.5231 45.065 44.1191 44.6261 44.559Z",
    fill: "#1731AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f2bcdbf0ada04a03d336d96f5f08417a.svg";
export { ForwardRef as ReactComponent };